import React from "react";

function AddFirstEducation({setActiveEducationPage}) {
  return (
    <div className="flex flex-col space-y-6 w-[72%]">
      <div className="px-10 py-6 bg-white rounded shadow-lg">
        {/* Education Details Heading */}
        <h2 className="text-gray-800 text-lg font-semibold mb-4">
          Education Details
        </h2>
        <hr className="border-t border-gray-300 mb-8" />

        {/* Centered Content */}
        <div className="flex flex-col items-center justify-center space-y-4">
          {/* Centered Image */}
          <img
            src="https://cdn-icons-png.flaticon.com/512/3976/3976625.png"
            alt="Education Icon"
            className="w-32 h-32"
          />

          {/* No Education Heading */}
          <h3 className="text-xl font-semibold text-gray-700">
            NO EDUCATION YET
          </h3>

          {/* Description Text */}
          <span className="text-gray-500 text-center">
            Currently you don't have any education in the system, please add at
            least one to continue
          </span>

          {/* Add Education Button */}
          <button 
            onClick={() => setActiveEducationPage('add-education')}
            className="mt-4 bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition-colors duration-300">
            Add Education
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddFirstEducation;
